<template>

  <b-card
  
    v-bind:img-src="imgfoto"
    img-alt="Image"
    img-top
    tag="article"
    style="max-width: 18rem;"
    class="m-3 text-center"
  >
    <b-card-text>
    <div style="height:80px">
{{prod.title}}
    </div>
    </b-card-text>

<act-modal-texto 
    :texto="prod.descricao"
    :titulo="prod.title"
    :id="nomemodal"
    class="mb-2"
>
</act-modal-texto>   

<act-desc-prog v-if="prod.entranocarrinho == 'S'"
    :texto="textodesconto"
    :titulo="prod.title"
    :id="nomemodal"
    class="mb-2"
>
</act-desc-prog>



    <b-card-text>
<span v-if="prod.entranocarrinho == 'S'"  class="text-primary mx-auto">{{ prod.price | currency("R$") }}</span>
<span v-else class="text-primary mx-auto">Entre em contato conosco</span>
    </b-card-text>
    <b-card-text>
<div v-show="prod.entranocarrinho == 'S'"  class="text-primary mx-auto">{{ prod.complemento }}</div>
<div v-show="prod.entranocarrinho == 'S'"  class="text-primary mx-auto">{{ prod.complemento2 }}</div>
<span v-show="prod.entranocarrinho != 'S'" class="text-primary mx-auto"></span>

<div v-show="prod.entranocarrinho == 'N'"  class="text-primary mx-auto">&nbsp;</div>
<div v-show="prod.entranocarrinho == 'N'"  class="text-primary mx-auto">&nbsp;</div>
<div v-show="prod.entranocarrinho == 'N'" class="text-primary mx-auto">&nbsp;</div>
<div v-show="prod.entranocarrinho == 'N'" class="text-primary mx-auto">&nbsp;</div>

    </b-card-text>


    <template #footer>
        <b-button v-if="prod.entranocarrinho == 'S'" block href="#" variant="danger" @click="clickAdd(prod,$event)">
          <b-icon icon="cart-plus"></b-icon>
          Adicionar ao Carrinho
        </b-button> 

        <div v-else>
           <b-button v-b-modal.my-modal-consulte variant="primary">
            <b-icon icon='search'></b-icon>
           Consulte
           
           </b-button>
           <b-modal id="my-modal-consulte" title="Entre me Contato">
            <b-row v-html="textoconsulta" class="m-3">
             {{textoconsulta}} 
            </b-row> 
           </b-modal>
        </div>

    </template>

    </b-card>
   
</template>

<script>
import { mapGetters } from "vuex"
import ActModalTexto from './ActModalTexto.vue'
import ActDescProg from './ActDescProg.vue'
export default {
  components: {
       ActModalTexto,
       ActDescProg
    },
    data: function() {
      return {
        id:1000,
        titulo:"Entre em Contato"
      }  
    },
     props: ['prod','foto','entranocarrinho'],
     computed: {
         nomemodal: function() {
            return '_prd_'+this.prod.id
         },
         imgfoto: function() {
               return this.foto

         } ,
         fone() {
           return this.$store.getters.getFone
         },
         email() {
           return this.$store.getters.getEmail
         },
         textodesconto() {
           return this.$store.getters.getTxtDescProg
         },
         textoconsulta() {
            return this.fone+"<br>email:"+this.email
         },
          ...mapGetters(['getCartItems'])
         
     },
     methods: {
          clickAdd: function (prod,e) {
            
          console.log(e)
           
          let itemToAdd = prod;
         
          // add the item or increase quantity
          let itemInCart = this.getCartItems.filter(
            (item) => item.id === itemToAdd.id
          );
          let isItemInCart = itemInCart.length > 0;

          if (isItemInCart === false) {
            this.$store.commit('addItemCart',itemToAdd)
            

            this.$bvToast.toast('Item adicionado com sucesso', {
              title: "Adicionado ao carrinho",
              variant: 'success',
              autoHideDelay: 5000,
              solid: true
            })


          } else {
            itemInCart[0].quantity += itemToAdd.quantity;
          }
          itemToAdd.quantity = 1;
        },
        abrirConsulte() {
          
        }
     }
     

}
</script>
  


<style scoped>

.btn-primary {
  color:#fff;
  background-color: #002046;
  border-color: #002046;
}

.btn-danger {
  color:#fff;
  background-color: #002046;
  border-color: #002046;
}
p {
      font-family: 'Poppins' !important;
  }
</style>